import { LockFilled, UserOutlined, MailOutlined } from "@ant-design/icons";
import { Row, Col, Alert, Button, Divider, Flex, Form, Input, Space, Typography } from "antd";
import { useState } from 'react';
import intl from 'react-intl-universal';
import _ from 'lodash-es';

import OpenIdHelper from "../../../libs/OpenIdHelper";
import request from "../../../libs/request";
import Evisit from "../../../libs/Evisit";

const { Link, Title } = Typography;

const ResetPasswordForm = () => {
    const [form] = Form.useForm();
    const [disabled, setDisabled] = useState(false);
    const [alert, setAlert] = useState(null);

    const onFinish = async () => {
        setDisabled(true);
        setAlert(null);
        try {
            const response = await request.post(`${window.base_url}/api_v3/users/reset_password`, {
                email: form.getFieldValue('email').trim()
            });
            if (_.get(response, "data")) {
                setAlert({
                    message: intl.get("check_pwd_email").d("Please check your email for instruction to reset your password."),
                    type: "success"
                });
            }
        } catch (error) {
            setDisabled(false);
            setAlert({
                message: error.response.data.message || error.message,
                type: "error"
            });
        }
    }

    return (
        <Space direction="vertical" size="middle" style={{display: 'flex'}}>
            {alert && <Alert message={alert.message} type={alert.type} />}
            <Form
                form={form}
                layout="vertical"
                autoComplete="off"
                disabled={disabled}
                onFinish={onFinish}
            >
                <Form.Item name="email" rules={[{ required: true }]}>
                    <Input
                        placeholder={intl.get("enter_email").d("Enter email address")}
                        aria-label="Enter email address"
                        addonBefore={<MailOutlined />}
                    />
                </Form.Item>
                <Form.Item>
                    <Button type="primary" htmlType="submit" block size="large">
                        {intl.get("reset_pwd").d("Reset Your Password")}
                    </Button>
                </Form.Item>
            </Form>
        </Space>
    );
};

const OpenIdLink = (props) => {
    var enabled = OpenIdHelper.isEnabled({
        type: props["type"],
        user_type: window.CONST.USER.TYPE.MEMBER
    });
    var rootPath = (process.env.NODE_ENV === "development") ? process.env.PUBLIC_URL : window.eks_webroot + "/pages/workflows";

    const btnText = () => {
        var text = "";
        if (props["type"] === "google") {
            text = intl.get("google_signin").d("Sign In with Google");
        } else if (props["type"] === "apple") {
            text = intl.get("apple_signin").d("Sign In with Apple");
        } else if (props["type"] === "facebook") {
            text = intl.get("facebook_signin").d("Sign In with Facebook");
        } else if (props["type"] === "sharecare") {
            text = _.get(window.CONFIG, "Settings.auth_providers.sharecare.login_text");
        }
        return text;
    }

    return (
        enabled &&
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            <a
                id={"openid-" + props["type"] + "-login-btn"}
                className="btn openid-login-btn"
                referrerPolicy="no-referrer-when-downgrade"
                onClick={() => {
                    const referrer = `${window.webroot}/members/login`;
                    const loginUrl = _.get(window.CONFIG, "Settings.auth_providers." + props["type"] + ".login") + 
                         "?type=" + props["type"] + "&clinic_code=" + window.CONFIG.Account.code + 
                         "&referrer=" + encodeURIComponent(referrer);
                    Evisit.postMessageBackToParent({ 
                        name: 'redirect', 
                        url: loginUrl,
                        injectParams: {
                            next: "action=appointment#schedule-appointment"
                        }
                    });
                }}
            >
                <img
                    src={rootPath + '/static/img/' + props["type"] + '_logo.png'}
                    alt={props["type"]}
                    className={"openid-login-icon openid-" + props["type"] + "-login-icon"}
                    cdn="true"
                />
                { btnText() }
            </a>
    );
}

const OpenIdComponent = () => {
    const facebookEnabled = OpenIdHelper.isEnabled({
        type: "facebook",
        user_type: window.CONST.USER.TYPE.MEMBER
    });
    const googleEnabled = OpenIdHelper.isEnabled({
        type: "google",
        user_type: window.CONST.USER.TYPE.MEMBER
    });
    const sharecareEnabled = OpenIdHelper.isEnabled({
        type: "sharecare",
        user_type: window.CONST.USER.TYPE.MEMBER
    });
    const appleEnabled = OpenIdHelper.isEnabled({
        type: "apple",
        user_type: window.CONST.USER.TYPE.MEMBER
    });

    return (<>
        { (facebookEnabled || googleEnabled || appleEnabled || sharecareEnabled) &&
            <Divider style={{color: "#ddd", marginTop: 0}}> {intl.get("or").d("OR")} </Divider>
        }
        <div className="openid-login-container">
            <OpenIdLink type="google" />
            <OpenIdLink type="facebook" />
            <OpenIdLink type="sharecare" />
            <OpenIdLink type="apple" />
        </div>
    </>);
}

const LoginComponent = ({ currentComponent, onNext, onPrevious, workflow }) => {
    const [form] = Form.useForm();
    const [resetPassword, setResetPassword] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [memberLogining, setMemberLogining] = useState(false);
    const [guestLogining, setGuestLogining] = useState(false);
    const guestEnabled = _.get(window.CONFIG, 'Account.sso.enable')
                && _.get(window.CONFIG, 'Account.sso.settings.' + window.CONST.USER.TYPE.GUEST + '.enable')
                && _.get(window.CONFIG, 'Account.waiting_room.auth.guest.log_in.enabled');
    const loginAsUser = async () => {
        setMemberLogining(true);
        setErrorMessage('');
        try {
            const response = await request.post(`${window.base_url}/api_v3/users/login`, {
                username: form.getFieldValue('email').trim(),
                password: form.getFieldValue('password')
            });

            window.user = {
                ...response.data.user,
                token: response.data.token
            }
            onNext();
        } catch (error) {
            setMemberLogining(false);
            setErrorMessage(error.response.data.message || error.message)
        }
    }

    const proceedAsGuest = async () => {
        onNext({});
    }

    return (
        <Row>
            <Col sm={5} xs={0} >
            </Col>
            <Col sm={14} xs={24} >
                <Space direction="vertical" size="middle" style={{ display: "flex" }} className="align-center">
                    <Flex justify="center" vertical align="center" gap="middle">
                        <Title
                            level={5}
                            style={{ fontWeight: "normal", margin: 0 }}
                        >
                            { Evisit.t('patient', [window.CONST.CAPITAL.ALL, window.CONST.PLURAL]) }
                        </Title>
                        <Title
                            level={2}
                            style={{margin: 0}}
                        >
                            { intl.get("log_in").d("Log In") }
                        </Title>
                    </Flex>
                    { guestEnabled && workflow["code"] === "walkin" && <>
                        <Button
                            type="primary"
                            block
                            size="large"
                            disabled={memberLogining}
                            loading={guestLogining}
                            onClick={() => proceedAsGuest()}
                        >
                            { intl.get("guest_walkin").d("Enter Waiting Room As Guest") }
                        </Button>
                        <Divider plain style={{color:"#ddd"}}>
                            { intl.get("or").d("OR") }
                        </Divider>
                    </>}
                    {errorMessage && <Alert message={errorMessage} type={"error"} showIcon={true}/>}
                    <Form
                        name="login_form"
                        form={form}
                        justify="center"
                        disabled={memberLogining || guestLogining}
                        onFinish={loginAsUser}
                        autoComplete="off"
                    >
                        <Form.Item
                            name="email"
                            rules={[
                                {
                                    required: true,
                                    message: "Please input your username!",
                                },
                            ]}
                        >
                            <Input
                                placeholder="Email"
                                aria-label="Input Email"
                                addonBefore={<UserOutlined />}
                            />
                        </Form.Item>

                        <Form.Item
                            name="password"
                            rules={[
                                {
                                    required: true,
                                    message: "Please input your password!",
                                },
                            ]}
                        >
                            <Input.Password
                                placeholder="Password"
                                aria-label="Input Password"
                                addonBefore={<LockFilled />}
                            />
                        </Form.Item>
                        <Form.Item>
                            <Button
                                type={guestEnabled ? "default" : "primary"}
                                htmlType="submit"
                                block
                                size="large"
                                loading={memberLogining}
                            >
                                { intl.get("log_in").d("Log In") }
                            </Button>
                        </Form.Item>
                        <div>
                            {intl.get("no_account").d("Don't have an account?")} <Link onClick={() => {
                                window.top.location.href = "https://" + window.CONFIG.Account.domain + window.webroot + "/members/signup";
                            }}>{intl.get("signup_now").d("Sign up now")}</Link>
                        </div>
                    </Form>
                    <Link onClick={() => {setResetPassword(!resetPassword);}}>
                        {intl.get("forgot_pwd").d("Forgot Password")}
                    </Link>
                    { resetPassword && <ResetPasswordForm /> }
                    { <OpenIdComponent /> }
                </Space>
            </Col>
            <Col sm={5} xs={0} >
            </Col>
        </Row>
    );
};

export default LoginComponent;
